import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const ANALYZIFY_INTEGRATION_NAME = 'analyzify';
export const ZAnalyzifyIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(ANALYZIFY_INTEGRATION_NAME),
    category: z.literal('analytics'),
    credentials: z.object({}).optional(),
    settings: z.object({}).optional(),
}).shape);
//# sourceMappingURL=analyzify.js.map